import { number } from 'yup'

export const patternTwoDigisAfterComma = /^\d+(\.\d{0,2})?$/

export const numberSchema = number().typeError('${label} must be a number')

export const daysSchema = number()
  .positive()
  .integer()
  .min(0).typeError('${label} must be an integer')

export const decimalSchema = numberSchema.test(
    'maxDigitsAfterDecimal',
    '${label} format is invalid',
    (number) => (!number || patternTwoDigisAfterComma.test(number))
)
